<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <cost-centers></cost-centers>
    </v-container>
  </div>
</template>
<script>
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";
import CostCenters from "@/components/Definiciones/CentrosDeCosto/CostCenters.vue"
    
    export default {
    components: { LandingToolbar, CostCenters},
    };
</script>